export module campsenum {
    export enum RefundReason {
        Complimentary = 0,
        CustomerChangedMind = 1,
        EmployeeError = 2,
        Training = 3,
        Other = 4
    }
}
export module campsenum {
    export enum ErrorCode {
        MandatoryFieldsMissing = 110,
        RequestParametersNotFound = 111,
        ValidationError = 112,
        EntityNotFound = 113,
        EmployeeSaveMandatoryFieldsMissing = 401,
        CartIsEmptyOrDontExists = 500,
        SessionIsNotEliglibleForChild = 510,
        DayVariantIsAlreadySold = 511,
        ChildIsAlreadyEnrolledInOverlappingSession = 512,
        ChildIsAlreadyEnrolledInSession = 513,
        ChildIsAlreadyAddedInSession = 514,
        SessionIsNotAddedToCart = 515,
        ChildIsAlreadyEnrolledInCampCareBooking = 516,
        CustomVariantIsNotAllowedForSession = 517,
        CannotCleanCartThatIsNotInProgress = 518,
        ChildIsAlreadyEnrolledInOverlappingWeek = 519,
        CostMissingCalculationParamenters = 601,
        CostMissingSessions = 602,
        CostMissingDiscountConfiguration = 604,
        CostNotEnoughPointsToRedeem = 605,
        CostPurchaseIsAlreadyFinalized = 606,
        CostMissingCart = 607,
        UnexpectedErrorWhilePaying = 710,
        PurchaseNoLongerAvailable = 711,
        PaymentVerificationFailed = 705,
        MemberChargeNotAllowed = 706,
        CannotRetrieveCreditLimit = 707,
        CannotCalculatePaymentMethodFeeInfo = 708,
        MemberNotFound = 800,
        ChildNoLongerExists = 850,
        ChildCannotBeAddedToCart = 851,
        ChildNotFound = 852,
        CannotRetrievePurchaseDetails = 900,
        CannotRetrievePurchasedSessionDetails = 901,
        PurchaseIsNotFinalized = 1000,
        CampNameShouldBeUnique = 1101,
        CampIsNotActive = 1102,
        AdvancedBookingDaysLimitExceeded = 1103,
        CampHasNoRegularSessionOnThatDay = 1201,
        CampCareDayOverlapsAnother = 1202,
        CampCareInvalidAgeRange = 1204,
        CampCareInvalidDateRange = 1205,
        CampCareDaySlotsAreNotDisjunctiveRule = 1206,
        CampDoesNotExist = 1207,
        ClubDoesNotExist = 1208,
        CampCareDayDoesNotExist = 1209,
        CampCareSlotsNotDefined = 1210,
        CampCareDayIsInInproperStatusToActivate = 1211,
        CampCareDayIsInInproperStatusToArchive = 1212,
        CampCareHasFutureBookings = 1213,
        CampCareHasNoSlots = 1214,
        CampCareSlotIsNotYetAvailable = 1215,
        CampCareIsNotEnabled = 1300,
        CampCareDayIsFullyBooked = 1301,
        OtherCampCareIsAlreadyBookedForChildInTheSameTime = 1302,
        OtherSessionIsAlreadyBookedForChildInTheSameTime = 1303,
        CannotChangeCampStatus = 1400,
        DescriptionMustBeProvidedIfCampIsVisibleToMembers = 1401,
        SessionCannotBeSold = 1403,
        CannotRemoveDiscount = 1404,
        CannotEditDiscount = 1405,
        CannotRemoveOption = 1406,
        CannotEditOption = 1407,
        SesionDaysDontExists = 1408,
        CannotRemoveDayVariant = 1409,
        CannotEditDayVariant = 1410,
        SessionDayUsedInDayVariant = 1411,
        SessionSoldCannotBeRemoved = 1412,
        SessionCapacityToSmall = 1413,
        DiscountDateFromMustBeBeforeDateTo = 1414,
        EnrolledChildrenNotEligible = 1415,
        CannotChangeStatusFromActiveToClosed = 1416,
        CannotChangeStatusFromActiveToDraft = 1417,
        CannotChangeStatusFromDraftToActive = 1418,
        SessionDayUsedInCampCare = 1419,
        DayVariantDaysSetIsNotDistinct = 1420,
        TimeRangeIsInvalid = 1421,
        SessionAgeRangeDoNotCoverCampCareAgeRange = 1422,
        DiscountMinParamMustBeLowerOrEqualMax = 1423,
        DiscountApplicationOrderIsRequired = 1424,
        DiscountOrderMustBeUnique = 1425,
        SessionTimeVariantDoNotCoverCampCareSlots = 1426,
        SessionMoveInDaysCannotBeZero = 1700,
        SessionMoveInDaysMustBeFullWeek = 1701,
        CurrentCartDontExists = 1427,
        OriginalCartDontExists = 1428,
        ReturnedAmountExceedsOriginalPaymnent = 1429,
        PurchaseIsTheSameAsOriginal = 1430,
        OriginalPurchaseWasModified = 1431,
        CannotModifyPurchaseWwhenCouponApplied = 1432,
        CannotRefundPaymentProcessorPurchase = 1433,
        CampCheckinChildIsCheckedIn = 1501,
        CannotCheckinInDifferentClub = 1502,
        SupervisorHasNoRightsToVisit = 1503,
        SupervisorHasNoRightsToChildren = 1504,
        ChildIsNotSignedUpForReservation = 1505,
        ChildIsAlreadyCheckedOut = 1506,
        ChildIsNotCheckedIn = 1507,
        CannotCheckoutInDifferentClub = 1508,
        IsTooEarlyToDropOffChild = 1509,
        SupervisorDataDoesNotExist = 1510,
        UnableToGenerateCouponCode = 1600,
        CannotDeactivateCoupon = 1601,
        CannotActivateCoupon = 1602,
        CouponDontExist = 1603,
        CouponNotSend = 1604,
        IncorrectPercentageCouponParameters = 1605,
        IncorrectCouponType = 1606,
        IncorrectAmountCouponParameters = 1607,
        ValidityEndDateMustBeInTheFuture = 1608,
        EmailIsRequiredIfSendSelected = 1609,
        MaxValueRuleMustBeGreaterThanZero = 1610,
        CouponIsNotValid = 1611,
        CouponCannotBeAppliedWithFreeCampdays = 1612,
        CouponIsNotAppliedInCart = 1613,
        CouponIsExpired = 1614,
        OnlyOneCouponPerPurchaseCanBeApplied = 1615,
        PercentageCouponMaxAmountIsRequired = 1616,
        IncorrectFreeWeeksCouponParameters = 1617,
        ManuallyProvidedCouponCodeMustBeUnique = 1618,
        PurchasePriceIsNotZeroCannotBeFinalized = 1700
    }
}
export module campsenum {
    export enum CampPurchaseSource {
        Connect = 0,
        Office = 1
    }
    export enum CampPurchaseStatus {
        InProgress = 0,
        PaymentAvailable = 1,
        Finalized = 2,
        PaymentNotValid = 3,
        Abandoned = 4,
        Refunded = 5,
        Modified = 6
    }
}
export module campsenum {
    export enum CampCareStatus {
        Disabled = 0,
        Active = 1,
        Draft = 2,
        Closed = 3
    }
    export enum CampStatus {
        Draft = 0,
        Active = 1,
        Closed = 2,
        Removed = 3
    }
    export enum CampType {
        Standard = 0,
        Childcare = 1,
        School = 2,
        AfterSchool = 3,
        Summer = 4
    }
    export enum DiscountType {
        PayInFull = 0,
        EnrollmentDays = 1,
        MembershipTier = 2,
        NumberOfDays = 3,
        Siblings = 5,
        EarlyBird = 6,
        PayInFull2020 = 7
    }
    export enum OptionType {
        AddIn = 1,
        OptOut = 2
    }
    export enum ReservationDaysAheadLimitVariant {
        ByCalendarDays = 0,
        ByStartTime = 1
    }
    export enum TimeRangeVariantType {
        FullDay = 1,
        HalfDay = 2,
        Morning = 3,
        Afternoon = 4,
        Evening = 5,
        Other = 6
    }
}
export module campsenum {
    export enum CouponActionType {
        Creation = 0,
        Activation = 1,
        Deactivation = 2,
        Sent = 3,
        UsedInCart = 4,
        RemovedFromCart = 5,
        AbandonedCart = 6
    }
    export enum CouponStatus {
        Created = 0,
        Used = 1,
        Deactivated = 2,
        Expired = 3
    }
    export enum CouponType {
        Amount = 0,
        Percentage = 1,
        FreeDays = 2,
        FreeWeeks = 3
    }
    export enum CouponUsageType {
        Single = 0,
        Multiple = 1
    }
}
export module campsenum {
    export enum CampCareBookingStatus {
        New = 0,
        Confirmed = 1,
        Cancelled = 2
    }
    export enum CampCareDayStatus {
        Active = 1,
        Archived = 2
    }
}
export module campsenum {
    export enum Gender {
        Male = 0,
        Female = 1,
        Other = 2,
        Unknown = 3
    }
    export enum HistorySearchType {
        All = 0,
        Historical = 1,
        Upcoming = 2
    }
    export enum MembershipTier {
        Unknown = 0,
        Family = 1,
        Couple = 2,
        Individual = 3,
        Employee = 4,
        NonMember = 5,
        Circle = 6,
        CirclePif = 7
    }
    export enum PaymentMethod {
        CreditCard = 0,
        MemberCharge = 1,
        CreditDays = 2,
        Coupon = 3,
        DebitCard = 4,
        GiftCard = 5
    }
}
export module campsenum {
    export enum SortOrder {
        None = 0,
        Asc = 1,
        Desc = 2
    }
}
